<template>
    <div class="content">
        <base-header class="pb-6">
            <div class="row align-items-center py-4">
                <div class="col-lg-6 col-7">
                    <h6 class="h2 text-white d-inline-block mb-0">
                        {{ $t("menu.admin_product_v2") }}
                    </h6>
                    <nav
                        aria-label="breadcrumb"
                        class="d-none d-md-inline-block ml-md-4"
                    >
                        <route-bread-crumb></route-bread-crumb>
                    </nav>
                </div>

                <div class="col-lg-6 col-5 text-right">
                        <!-- #280: sync the WHOLE selected Shopee shop into
                             seller. Only for Shopee (platform_id 3) and only
                             once a shop is picked — the job is keyed by
                             (enterprise, platform_shop_id), so without a shop
                             there is nothing to start. -->
                        <base-button size="md" type="neutral"
                                        v-if="isShopeeShopSelected"
                                        @click.native="handleOpenBulkSync()"
                                        class="edit"
                        >
                                        <i class="fa fa-cloud-download-alt mr-1"></i>
                                        {{ $t("shopee_bulk_sync.btn_toolbar") }}
                        </base-button>
                        <base-button size="md" type="neutral"
                                        @click.native="showSyncModal = true"
                                        class="edit"
                                        icon
                        >
                                        <i class="fa fa-sync"></i>
                                        Sync
                        </base-button>
                </div>

            </div>
        </base-header>
        <div class="container-fluid mt--6">
            <div>
                <card
                    class="no-border-card"
                    body-classes="px-0 pb-1"
                    footer-classes="pb-2"
                >
                    <template slot="header">
						<div class="row">
							<div class="col-lg-12">
							<h2>Platform Product</h2>
							</div>
						</div>
						<div class="row">
                        <div class="col-lg-3">
                            <base-input
                                v-model="keyword"
                                prepend-icon="fas fa-search"
                                placeholder="Search name or code"
                            >
                            </base-input>
                        </div>

						<div class="col-md-2">
							<base-input>
								<el-select
									v-model="selectedPlatformId"
									placeholder="Platform"
									@change="handlePlatformChange"
								>
									<el-option
										v-for="option in PlatformTable"
										:key="option.id"
										:label="option.name"
										:value="option.id"
									>
									</el-option>
								</el-select>
							</base-input>
						</div>

						<div class="col-md-2">
							<base-input>
								<el-select
									v-model="selectedShopId"
									placeholder="Shop"
								>
									<el-option
										v-for="shop in filteredShops"
										:key="shop.id"
										:label="shop.seller_name"
										:value="shop.id"
									>
									</el-option>
								</el-select>
							</base-input>
						</div>

						 <div class="col-md-2">
                                <base-input>
                                    <el-select
                                        v-model="productStatus"
                                        :placeholder="$t('status')"
                                    >
                                        <el-option
											v-for="option in StatusTable"
                                            :key="option.id"
                                            :label="option.name"
                                            :value="option.id"
                                        >
                                        </el-option>
                                    </el-select>
                                </base-input>
                            </div>

						<div class="col-md-2">
                                <base-input>
                                    <el-select
                                        v-model="map_sku_type"
                                        placeholder="Map SKU"
                                    >
                                        <el-option
											v-for="option in MapSkuTypeTable"
                                            :key="option.id"
                                            :label="option.name"
                                            :value="option.id"
                                        >
                                        </el-option>
                                    </el-select>
                                </base-input>
                            </div>

						<div class="col-md-1">
								<base-button
                                        @click.native="handleSearch()"
                                        class="edit"
                                        type="warning"
                                        size="md"
                                        icon
                                    >
                                        <i class="text-dtac-bt fa fa-search"></i>
                                    </base-button>

						</div>
						</div>
						<!-- #180: MDFStore = storefront-synced shadow products (platform 9). -->
						<div class="row" v-if="selectedPlatformId === 9">
							<div class="col-lg-12">
								<div class="alert alert-warning py-2 px-3 mb-0">
									<i class="fa fa-info-circle mr-1"></i>
									{{ $t("product_platform_v2.mdfstore_hint") }}
								</div>
							</div>
						</div>
						<!-- Makro = Mirakl-synced offer shadow products (platform 10). -->
						<div class="row" v-if="selectedPlatformId === 10">
							<div class="col-lg-12">
								<div class="alert alert-warning py-2 px-3 mb-0">
									<i class="fa fa-info-circle mr-1"></i>
									{{ $t("product_platform_v2.makro_hint") }}
								</div>
							</div>
						</div>




                    </template>

                    <div>
                        <el-table
                            :data="queriedData"
                            row-key="id"
                            header-row-class-name="thead-light"
                        >

							<el-table-column label="" >
								<div slot-scope="{  row }" >
									<img :src="GetProductUrl(row.images)" height="60px" class="mr-3" style="border-radius: 4px;" v-if="row.images && (row.images.includes('.png') || row.images.includes('.jpg') || row.images.includes('jpeg') || row.images.includes('http'))"/>
								</div>
                            </el-table-column>

                            <el-table-column :label="$t('name')" min-width="300">
								<div slot-scope="{  row }">
									<div class="d-flex align-items-center">
										<a href="#" @click.prevent="handleShowStockDetail(row)" class="text-primary" style="cursor: pointer; text-decoration: underline;">
											{{ row.name}}
										</a>
									</div>
									<!-- #260: "already in seller" badge, from
										 GET /api/platform/v2/shopee/products/seller-links
										 (one batched call per loaded page). -->
									<div v-if="sellerLinkOf(row)" class="mt-1">
										<span class="badge badge-success">
											{{ $t("shopee_to_seller.badge_linked") }}
											<span v-if="sellerLinkOf(row).last_synced_at">
												· {{ formatDateTime(sellerLinkOf(row).last_synced_at) }}
											</span>
										</span>
									</div>
								</div>
                            </el-table-column>

                            <el-table-column :label="$t('code')" >
								<div slot-scope="{  row }" >
									{{ row.code}}
								</div>
                            </el-table-column>

							<!-- <el-table-column :label="$t('shipping_cost')" >
								<div slot-scope="{  row }" >
									{{ row.shipping_cost}}
								</div>
                            </el-table-column> -->

							<el-table-column label="Sync" width="100" align="center">
								<div slot-scope="{ row }" class="d-flex justify-content-center">
									<el-switch
										v-model="row.stock_sync_enabled"
										:active-value="1"
										:inactive-value="0"
										active-color="#13ce66"
										inactive-color="#909399"
										@change="handleStockSyncToggle(row)"
									>
									</el-switch>
								</div>
							</el-table-column>

                            <el-table-column
                                align="center"
                                :label="$t('actions')"
                            >
                                <div
                                    slot-scope="{ $index, row }"
                                    class="d-flex"
                                >
                                    <!-- #180: open the SKU -> WMS mapping form for this
                                         product (shared with the per-platform product
                                         list; generic, no platform restriction). -->
                                    <base-button
                                        @click.native="handleEditProduct(row)"
                                        class="edit btn-link mr-1"
                                        type="warning"
                                        size="sm"
                                        icon
                                        :title="$t('product_platform_v2.map_wms_btn')"
                                    >
                                        <i class="text-dtac-bt fa fa-edit text-white"></i>
                                    </base-button>
                                    <!-- #260: push this Shopee listing into the
                                         seller catalogue. Shopee rows only
                                         (platform_id === 3) — no other platform
                                         carries a Shopee item_id. -->
                                    <el-tooltip
                                        v-if="isShopeeRow(row)"
                                        :content="toSellerTooltip(row)"
                                        placement="top"
                                    >
                                        <span class="d-inline-block mr-1">
                                            <base-button
                                                @click.native="handleToSeller(row)"
                                                class="edit btn-link"
                                                type="primary"
                                                size="sm"
                                                :disabled="!!toSellerDisabledReason(row)"
                                            >
                                                <span class="text-white">{{ $t("shopee_to_seller.btn_send") }}</span>
                                            </base-button>
                                        </span>
                                    </el-tooltip>
                                    <base-button
                                        @click.native="
                                            handleDelete($index, row)
                                        "
                                        class="remove btn-link"
                                        type="danger"
                                        size="sm"
                                        icon
                                    >
                                        <i class="text-dtac-bt fa fa-trash  text-white"></i>
                                    </base-button>
                                </div>
                            </el-table-column>
                        </el-table>
                    </div>
                    <div
                        slot="footer"
                        class="col-12 d-flex justify-content-center justify-content-sm-between flex-wrap"
                        v-if="queriedData.length != 0"
                    >
                        <div class="">
                            <p class="card-category">
                                {{ $t("data") }} {{ from + 1 }} {{ $t("to") }}
                                {{ to }}
                                {{ $t("of") }}
                                {{ total }}
                                <span v-if="selectedRows.length">
                                    - &nbsp; &nbsp; {{ selectedRows.length }}
                                    {{ $t("row_select") }}
                                </span>
                            </p>
                        </div>
                        <base-pagination
                            class="pagination-no-border"
                            v-model="pagination.currentPage"
                            :per-page="pagination.perPage"
                            :total="total"
                        >
                        </base-pagination>
                    </div>
                </card>
            </div>
        </div>

        <modal :show.sync="showAddModal" modal-classes="modal-secondary">
            <form class="new-event--form" @submit.prevent="saveEvent">
                <base-input :label="$t('name')" v-model="params.name"> </base-input>

                <base-input :label="$t('description')" v-model="params.detail">
                </base-input>


                <input type="hidden" class="new-event--start" />
                <input type="hidden" class="new-event--end" />
            </form>

            <template slot="footer">
                <button
                    type="submit"
                    class="btn btn-md btn-primary"
                    @click="handleUpdate()"
                >
                    {{ $t("save") }}
                </button>
                <button
                    type="button"
                    class="btn btn-md btn-link ml-auto"
                    @click="showAddModal = false"
                >
                    {{ $t("close") }}
                </button>
            </template>
        </modal>

        <modal :show.sync="showSyncModal" modal-classes="modal-secondary">
            <h5 slot="header" class="modal-title">Sync Product Stock</h5>
            <form class="new-event--form" @submit.prevent="">
                <div class="row mb-3">
                    <div class="col-md-6">
                        <label class="form-control-label">Platform</label>
                        <p class="font-weight-bold">{{ GetPlatformName(selectedPlatformId) }}</p>
                    </div>
                    <div class="col-md-6">
                        <label class="form-control-label">Shop Name</label>
                        <p class="font-weight-bold">{{ getSelectedShopName() || '-' }}</p>
                    </div>
                </div>
                <div class="row mb-3">
                    <div class="col-md-12">
                        <label class="form-control-label">Shop ID</label>
                        <p class="font-weight-bold">{{ getSelectedShopId() || '-' }}</p>
                    </div>
                </div>
                <hr/>
                <base-input
                    label="Platform Product ID"
                    v-model="syncProductId"
                    placeholder="Enter platform product ID"
                >
                </base-input>
            </form>

            <template slot="footer">
                <button
                    type="submit"
                    class="btn btn-md btn-primary"
                    @click="handleSyncProduct()"
                    :disabled="!syncProductId || !getSelectedShopId()"
                >
                    Sync
                </button>
                <button
                    type="button"
                    class="btn btn-md btn-link ml-auto"
                    @click="showSyncModal = false"
                >
                    {{ $t("close") }}
                </button>
            </template>
        </modal>

        <!-- Loading Modal -->
        <modal :show.sync="isLoading" modal-classes="modal-sm" :show-close="false">
            <div class="text-center py-4">
                <i class="fa fa-spinner fa-spin fa-3x text-primary"></i>
                <p class="mt-3 mb-0">Processing...</p>
            </div>
        </modal>

        <!-- Stock Detail Modal -->
        <modal :show.sync="showStockDetailModal" modal-classes="modal-xl stock-detail-modal">
            <h5 slot="header" class="modal-title">
                Stock Detail: {{ selectedProduct ? selectedProduct.name : '' }}
            </h5>
            <div v-if="stockDetailData">
                <div class="row mb-3">
                    <div class="col-md-2" v-if="selectedProduct && selectedProduct.images">
                        <img :src="GetProductUrl(selectedProduct.images)" class="img-fluid rounded" style="max-height: 120px;" />
                    </div>
                    <div :class="selectedProduct && selectedProduct.images ? 'col-md-10' : 'col-md-12'">
                        <label class="form-control-label">Product Code</label>
                        <p class="font-weight-bold">{{ selectedProduct ? selectedProduct.code : '-' }}</p>
                    </div>
                </div>

                <!-- WMS Stock Summary -->
                <div class="mb-4" v-if="getRelatedWmsStock().length > 0">
                    <h6 class="mb-3">WMS Stock Summary</h6>
                    <div class="row">
                        <div class="col-md-4" v-for="(wmsProduct, idx) in getRelatedWmsStock()" :key="idx">
                            <div class="card bg-light mb-2">
                                <div class="card-body py-2 px-3">
                                    <div class="d-flex align-items-center">
                                        <img :src="GetProductUrl(wmsProduct.images)" height="50px" class="mr-3" style="border-radius: 4px;" v-if="wmsProduct.images"/>
                                        <div>
                                            <strong>{{ wmsProduct.name }}</strong>
                                            <div class="small">
                                                <span class="text-success mr-2">Available: {{ wmsProduct.Stock }}</span>
                                                <span class="text-warning mr-2">Packing: {{ wmsProduct.Packing }}</span>
                                                <span class="text-info">Balance: {{ wmsProduct.Balance }}</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="d-flex justify-content-between align-items-center mb-3">
                    <h6 class="mb-0">SKU Stock ({{ getRelatedSkuStock().length }} items)</h6>
                    <div class="text-right">
                        <small class="text-muted d-block" v-if="stockDetailData && stockDetailData.calculated_at">
                            Last calculated: {{ formatDateTime(stockDetailData.calculated_at) }}
                        </small>
                        <small class="text-muted d-block" v-if="stockDetailData && stockDetailData.duration">
                            Duration: {{ stockDetailData.duration }}
                        </small>
                    </div>
                </div>
                <el-table :data="getRelatedSkuStock()" header-row-class-name="thead-light" max-height="800">
                    <el-table-column prop="SkuName" label="SKU Name" width="400"></el-table-column>
                    <el-table-column prop="SkuCode" label="SKU Code" width="200"></el-table-column>
                    <el-table-column prop="Stock" label="Stock" width="80" align="center"></el-table-column>
                    <el-table-column prop="StockSyncEnabled" label="Sync" width="80" align="center">
                        <template slot-scope="{ row }">
                            <span :class="row.StockSyncEnabled ==1  && row.WmsProductSyncEnabled ==1 ? 'text-success' : 'text-danger'">
                                {{ row.StockSyncEnabled ==1 && row.WmsProductSyncEnabled ==1 ? 'Yes' : 'No' }}
                            </span>
                        </template>
                    </el-table-column>
                    <el-table-column label="WMS Products" min-width="180">
                        <template slot-scope="{ row }">
                            <div v-if="row.WmsProductName">
                                <div v-for="(product, idx) in parseWmsProducts(row.WmsProductName)" :key="idx" class="wms-product-item mb-2">
                                    <strong>{{ product.name }}</strong> x {{ product.pickup_quantity || 1 }}
                                    <div class="small text-muted">
                                        <span class="mr-2">Available: {{ product.availabel }}</span>
                                        <span class="mr-2">Packing: {{ product.packing }}</span>
                                        <span>WMS Stock: {{ product.balance }}</span>
                                    </div>
                                </div>
                            </div>
                            <span v-else>-</span>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <div v-else class="text-center py-4">
                <i class="fa fa-spinner fa-spin fa-2x text-primary"></i>
                <p class="mt-2 mb-0">Loading stock data...</p>
            </div>

            <template slot="footer">
                <button
                    type="button"
                    class="btn btn-md btn-secondary"
                    @click="showStockDetailModal = false"
                >
                    {{ $t("close") }}
                </button>
            </template>
        </modal>

        <!-- #260: Shopee -> seller modal (dry-run preview, then confirm). -->
        <shopee-to-seller-modal
            :show.sync="showToSellerModal"
            :row="toSellerRow"
            :linked="toSellerRowLinked"
            @synced="handleToSellerSynced"
        ></shopee-to-seller-modal>

        <!-- #280: whole-shop Shopee -> seller job (check, then real run). -->
        <shopee-bulk-sync-modal
            :show.sync="showBulkSyncModal"
            :shop-id="bulkShopId"
            :seller-name="bulkSellerName"
            @synced="handleBulkSynced"
        ></shopee-bulk-sync-modal>
    </div>
</template>
<script>
import { Table, TableColumn, Select, Option, Switch } from "element-ui";
import RouteBreadCrumb from "@/components/Breadcrumb/RouteBreadcrumb";
import { BasePagination } from "@/components";
import clientPaginationMixin from "../PaginatedTables/clientPaginationMixin";
import swal from "sweetalert2";
import { mapGetters, mapActions } from "vuex";
import { requestRefresh } from "@/utils/pageRefresh";
// #260 — Shopee -> seller. The rules (which rows, which tooltip, how the badge
// lookup is batched) live in a Vue-free module so they can be unit-tested; this
// repo's jest cannot mount .vue files.
import ShopeeToSellerModal from "./components/ShopeeToSellerModal.vue";
// #280 — whole-shop sync. Same split: the modal renders, @/utils/shopeeBulkSync
// decides.
import ShopeeBulkSyncModal from "./components/ShopeeBulkSyncModal.vue";
import { ShopeeService } from "@/resource";
import {
	isShopeeRow,
	SHOPEE_PLATFORM_ID,
	sendToSellerDisabledReason,
	buildSellerLinkRequests,
	indexSellerLinks,
	sellerLinkForRow
} from "@/utils/shopeeToSeller";

export default {
    mixins: [clientPaginationMixin],
    components: {
        BasePagination,
        RouteBreadCrumb,
        ShopeeToSellerModal,
        ShopeeBulkSyncModal,
        [Select.name]: Select,
        [Option.name]: Option,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
        [Switch.name]: Switch
    },
    computed: {
        ...mapGetters({
            getDataFor: "Product/getDataFor",
            getPlatformCurrentParams: "Product/getPlatformCurrentParams",
            sellers: "Platform/getSellers"
        }),
        // Own slot per list page (store comment on datasByKey): no cross-tab
        // overwrite between /admin/product, /admin/product/:platform and
        // /admin/product_platform while they are kept alive.
        tableDataOrg() {
            return this.getDataFor("admin_product_platform");
        },
        tableData: function() {
            if (this.productStatus != 0 || this.keyword != "") {
              return this.tableDataOrg.filter((m)=>{
				let c1 = true
				let c2 = true
				if (this.productStatus != 0) {
					c1 = m.status == this.productStatus
				}

				if (this.keyword != ""){
					var kw = this.keyword.toLowerCase()
					var nameMatch = m.name && m.name.toLowerCase().includes(kw)
					var codeMatch = m.code && m.code.toLowerCase().includes(kw)
					c2 = nameMatch || codeMatch
				}

                return c1 && c2
              });
            }
            return this.tableDataOrg;
        },
		searchParams:function(){
			let params = {
				platform_id: this.selectedPlatformId,
				map_sku_type: this.map_sku_type
			}
			if (this.selectedShopId > 0 && this.sellers) {
				var shop = this.sellers.find(s => s.id === this.selectedShopId)
				if (shop) {
					params.platform_shop_id = shop.shop_id
				}
			}
			if (this.productStatus > 0) {
				params.status = this.productStatus
			}
			return params
		},
		filteredShops: function() {
			if (!this.sellers) {
				return []
			}
			return this.sellers.filter(shop => {
				return shop.platform_id === this.selectedPlatformId
			})
		},
		// #260: the modal hides the category picker when the item is already
		// linked (an update keeps the seller category it has).
		toSellerRowLinked: function() {
			return !!this.sellerLinkOf(this.toSellerRow)
		},
		// #280: the whole-shop button belongs to the SHOP FILTER, not to a row.
		// The job is keyed by (enterprise, platform_shop_id) on the BE, so the
		// shop the page is currently filtered to IS the job's subject — and the
		// button must be hidden when that shop is not a Shopee shop (no other
		// platform has a Shopee item list) or when no shop is picked at all
		// (`selectedShopId === 0`, e.g. MDFStore/Makro which have no seller row).
		bulkShopId: function() {
			// getSelectedShopId() resolves the seller row's `shop_id`, i.e. the
			// platform_shop_id the BE expects — the same value the per-row
			// to-seller flow sends.
			return this.getSelectedShopId() || ""
		},
		// #284: the BACKOFFICE name of the selected seller row. The modal shows
		// it beside the shop's name on SHOPEE (which it fetches itself), so the
		// operator can see the two agree before starting a whole-shop sync.
		// getSelectedShopName() reads bo_seller.seller_name — the same string the
		// shop dropdown above the table shows.
		bulkSellerName: function() {
			return this.getSelectedShopName() || ""
		},
		isShopeeShopSelected: function() {
			return Number(this.selectedPlatformId) === SHOPEE_PLATFORM_ID && this.bulkShopId !== ""
		}

    },
	watch: {
		// #260: one batched seller-links lookup per loaded page. The list is
		// replaced wholesale by Product/listDataV3, so watching it covers the
		// initial load, a search, and a platform/shop change alike.
		tableDataOrg: function(rows, old) {
			// Another page's load replaces the whole datasByKey map, which
			// re-evaluates this computed with the SAME array — skip it.
			if (rows === old) return
			this.loadSellerLinks(rows)
		}
	},
    data() {
        return {
            propsToSearch: ["name"],
            selectedRows: [],
            showAddModal: false,
            showSyncModal: false,
            showStockDetailModal: false,
            syncProductId: "",
            isLoading: false,
            selectedProduct: null,
            stockDetailData: null,
			// #260
			showToSellerModal: false,
			toSellerRow: null,
			sellerLinks: {},
			// #280
			showBulkSyncModal: false,
			map_sku_type: 0,
			keyword: "",
			selectedPlatformId: 2,
			selectedShopId: 0,
            params: {
                id: 0,
                name: "",
                detail: "",
                price: "",
                cod: "",
                code: "",
				atrributes:"",
				tag:"",
				status:1,
				product_sku:"",
            },
			productStatus:1,
			StatusTable : [
				{id:0,name:"ทั้งหมด"},
				{id:1,name:"ใช้งาน"},
				{id:2,name:"ไม่ใช้งาน"},
			],
			MapSkuTypeTable : [
				{id:0,name:"ทั้งหมด"},
				{id:1,name:"ผูกคลังสินค้าแล้ว"},
				{id:2,name:"ยังไม่ได้ผูกคลังสินค้า"},
			],
			PlatformTable: [
				//{id:0,name:"ทั้งหมด"},
				//{id:1,name:"madamefin"},
				{id:2,name:"Tiktok"},
				{id:3,name:"Shopee"},
				{id:4,name:"Lazada"},
				{id:5,name:"Line"},
				//{id:8,name:"pancake"},
				// #180: MDFStore (storefront -> BO product sync, platform 9, #339).
				// Shadow products land here via the sweep; staff needs this option
				// to find + map SKU -> WMS so MDFStore orders can deduct stock.
				// Name kept as a literal (not $t()) to match the other entries in
				// this table, which are proper nouns and not translated either.
				{id:9,name:"MDFStore"},
				// Makro (Makro PRO / Mirakl marketplace, platform 10). Offers are
				// ingested by platformsync as shadow bo_product rows (no
				// enterprise_platform seller row — creds are config-only), so like
				// MDFStore this option has no shop and staff use it to find + map
				// offer SKU -> WMS so Makro orders can deduct stock.
				{id:10,name:"Makro"}
			]
        };
    },
    mounted() {
		var self = this
		let documentClasses = document.body.classList;
		documentClasses.remove("modal-open");
		this.listSeller().then(function() {
			self.selectFirstShop()
			self.listData(self.searchParams);
		});
		this.getParam()
    },
    methods: {
        ...mapActions({
            createData: "Product/createData",
            updateData: "Product/updateData",
            deleteData: "Product/deleteData",
            listDataFor: "Product/listDataFor",
			setPlatformCurrentParams : "Product/setPlatformCurrentParams",
			toggleStockSync: "Product/toggleStockSync",
			syncProduct: "Product/syncProduct",
			calculateStock: "Product/calculateStock",
			listSeller: "Platform/listSeller"
        }),
        listData(params) {
            return this.listDataFor({ key: "admin_product_platform", version: "v3", params });
        },
		handleSearch(){
			this.listData(this.searchParams);
		},
		handlePlatformChange() {
			this.selectFirstShop()
		},
		selectFirstShop() {
			if (this.sellers && this.sellers.length > 0) {
				var shops = this.sellers.filter(s => s.platform_id === this.selectedPlatformId)
				if (shops.length > 0) {
					this.selectedShopId = shops[0].id
				} else {
					this.selectedShopId = 0
				}
			} else {
				this.selectedShopId = 0
			}
		},
		GetPlatfromID(platform) {
			let platform_id = 0
			this.PlatformTable.forEach(v=>{
				if (v.name == platform)
				{
					platform_id = v.id
				}
			})

			return platform_id
		},
        setParam(){

            let params = {
				mappingStatus: this.map_sku_type,
				status : this.productStatus,
				currentPage: this.pagination.currentPage,
				platform_id: this.selectedPlatformId,
                platform_shop_id: this.selectedShopId,
                keyword: this.keyword,
			}

            console.log("Set Params",params)
            this.setPlatformCurrentParams(params)

        },
        getParam(){
            let params = this.getPlatformCurrentParams
            console.log("Get Params", params)

            // if some field missing used default
            if (params.platform_id == undefined || params.platform_shop_id == undefined || params.status == undefined)
            {
                console.log("Params not found")
                this.selectFirstShop()
                return
            }

            this.map_sku_type = params.mappingStatus
            this.productStatus = params.status
            this.selectedPlatformId = params.platform_id
            this.selectedShopId = params.platform_shop_id
            this.keyword = params.keyword

        },
		GetPlatformName(platformId) {
			const platform = this.PlatformTable.find(v => v.id === platformId)
			return platform ? platform.name : ""
		},
		getSelectedShopName() {
			if (!this.sellers || this.selectedShopId === 0) {
				return ""
			}
			var shop = this.sellers.find(s => s.id === this.selectedShopId)
			return shop ? shop.seller_name : ""
		},
		getSelectedShopId() {
			if (!this.sellers || this.selectedShopId === 0) {
				return ""
			}
			var shop = this.sellers.find(s => s.id === this.selectedShopId)
			return shop ? shop.shop_id : ""
		},
        handleCreate() {
			requestRefresh("/admin/product/form");
			this.$router.push({ name: "product_form" });

        },
		// #180: open the shared SKU -> WMS mapping form (same route used by the
		// per-platform product list, `PlatformProductForm.vue`). That handler
		// (BO-Product.go ProductPlatformUpdate) writes `wms_map` on bo_product_sku
		// keyed only by SKU id + enterprise_id — it has no platform_id whitelist,
		// so this works unmodified for MDFStore (9) shadow products same as any
		// other platform.
		// Spec 2026-10-07-bo-form-draft-clear-design.md §5 B2: the form loads
		// the product by route id (no row in params); requestRefresh = intent.
		handleEditProduct(row) {
			this.setParam()
			const platform = String(this.selectedPlatformId);
			requestRefresh("/admin/product/" + platform + "/" + row.id);
			this.$router.push({
				name: "platform_product_form",
				params: { platform: platform, id: row.id }
			});
		},
		// ---- #260: Shopee -> seller -------------------------------------
		isShopeeRow: isShopeeRow,
		toSellerDisabledReason(row) {
			return sendToSellerDisabledReason(row)
		},
		toSellerTooltip(row) {
			var reason = sendToSellerDisabledReason(row)
			return reason ? this.$t(reason) : this.$t("shopee_to_seller.btn_send")
		},
		handleToSeller(row) {
			if (sendToSellerDisabledReason(row)) return
			this.toSellerRow = row
			this.showToSellerModal = true
		},
		sellerLinkOf(row) {
			return sellerLinkForRow(this.sellerLinks, row)
		},
		// One batched call per shop for the rows currently loaded (<=200 ids
		// per call, buildSellerLinkRequests enforces both).
		loadSellerLinks(rows) {
			var self = this
			var requests = buildSellerLinkRequests(rows)
			if (!requests.length) {
				this.sellerLinks = {}
				return Promise.resolve()
			}
			return Promise.all(
				requests.map(function(req) {
					return ShopeeService.SellerLinks({
						platform_shop_id: req.platform_shop_id,
						item_ids: req.item_ids.join(",")
					})
						.then(function(resp) {
							return (resp && resp.data && resp.data.links) || []
						})
						.catch(function() {
							// A missing badge must never break the product list.
							return []
						})
				})
			).then(function(lists) {
				self.sellerLinks = indexSellerLinks(lists)
			})
		},
		// ---- #280: whole-shop sync ---------------------------------------
		handleOpenBulkSync() {
			if (!this.isShopeeShopSelected) return
			this.showBulkSyncModal = true
		},
		// A finished REAL run created/updated seller products across the whole
		// shop, so every badge on the page can be stale — reload the list and
		// let the tableDataOrg watcher re-run the batched seller-links lookup.
		handleBulkSynced() {
			this.listData(this.searchParams)
			return this.loadSellerLinks(this.tableDataOrg)
		},
		// After a real sync the badge for that row must be current.
		handleToSellerSynced(payload) {
			var self = this
			if (payload && payload.product_id) {
				// optimistic: show the badge immediately, then reconcile.
				var next = Object.assign({}, this.sellerLinks)
				next[String(payload.item_id)] = {
					product_id: payload.product_id,
					last_synced_at: new Date().toISOString()
				}
				this.sellerLinks = next
			}
			return this.loadSellerLinks(this.tableDataOrg).then(function() {
				return self.sellerLinks
			})
		},
		handleStockSyncToggle(row) {
			var self = this
			this.isLoading = true
			this.toggleStockSync({
				id: row.id,
				payload: { stock_sync_enabled: row.stock_sync_enabled }
			})
			.then(function(resp) {
				self.isLoading = false
				swal.fire({
					title: self.$t("edit_success"),
					text: "Stock sync " + (row.stock_sync_enabled ? "enabled" : "disabled"),
					icon: "success",
					confirmButtonClass: "btn btn-success btn-fill",
					buttonsStyling: false
				});
			})
			.catch(function(err) {
				self.isLoading = false
				// Revert the toggle on error
				row.stock_sync_enabled = row.stock_sync_enabled ? 0 : 1
				var errorMsg = (err.response && err.response.data && err.response.data.Msg) ? err.response.data.Msg : "error"
				var errorData = (err.response && err.response.data) ? err.response.data : null
				swal.fire({
					title: self.$t(errorMsg),
					text: self.getErrorText(errorData),
					icon: "error",
					confirmButtonClass: "btn btn-danger btn-fill",
					buttonsStyling: false
				});
			});
		},
		handleSyncProduct() {
			var self = this
			var params = {
				platform_id: this.selectedPlatformId,
				platform_shop_id: this.getSelectedShopId(),
				platform_product_id: this.syncProductId
			}
			this.syncProduct(params)
			.then(function(resp) {
				self.showSyncModal = false
				self.syncProductId = ""
				self.listData(self.searchParams)
				swal.fire({
					title: "Success",
					text: "Product synced successfully",
					icon: "success",
					confirmButtonClass: "btn btn-success btn-fill",
					buttonsStyling: false
				});
			})
			.catch(function(err) {
				var errorMsg = (err.response && err.response.data && err.response.data.Msg) ? err.response.data.Msg : "error"
				var errorCause = (err.response && err.response.data && err.response.data.Cause) ? err.response.data.Cause : ""
				swal.fire({
					title: self.$t(errorMsg),
					text: errorCause,
					icon: "error",
					confirmButtonClass: "btn btn-danger btn-fill",
					buttonsStyling: false
				});
			});
		},
        handleUpdate() {
            this.showAddModal = false;
            // Create

            if (this.params.id == 0) {
                this.createData(this.params)
                    .then(resp => {
                        this.listData(this.searchParams);
                        swal.fire({
                            title: this.$t("create_success"),
                            text: ``,
                            icon: "success",
                            confirmButtonClass: "btn btn-success btn-fill",
                            buttonsStyling: false
                        });
                    })
                    .catch(err => {
                        swal.fire({
                            title: this.$t(err.response.data.Msg),
                            text: this.getErrorText(err.response.data),
                            icon: "error",
                            confirmButtonClass: "btn btn-danger btn-fill",
                            buttonsStyling: false
                        });
                    });
            } else {
                // Update
                this.updateData({id:this.params.id,payload:this.params})
                    .then(resp => {
                        this.listData(this.searchParams);
                        swal.fire({
                            title: this.$t("edit_success"),
                            text: ``,
                            icon: "success",
                            confirmButtonClass: "btn btn-success btn-fill",
                            buttonsStyling: false
                        });
                    })
                    .catch(err => {
                        swal.fire({
                            title: this.$t(err.response.data.Msg),
                            text: this.getErrorText(err.response.data),
                            icon: "error",
                            confirmButtonClass: "btn btn-danger btn-fill",
                            buttonsStyling: false
                        });
                    });
            }
        },
        handleDelete(index, row) {
			this.setParam()
            swal.fire({
                title: this.$t("delete_confirm"),
                text: this.$t("delete_confirm_question") + row.name,
                icon: "warning",
                showCancelButton: true,
                confirmButtonClass: "btn btn-success btn-fill",
                cancelButtonClass: "btn btn-danger btn-fill",
                confirmButtonText: this.$t("confirm"),
                cancelButtonText: this.$t("cancel"),
                buttonsStyling: false
            }).then(result => {
                if (result.value) {
                    this.deleteData(row.id)
                        .then(resp => {
                            this.listData(this.searchParams);
                            swal.fire({
                                title: this.$t("delete_success"),
                                text: ``,
                                icon: "success",
                                confirmButtonClass: "btn btn-success btn-fill",
                                buttonsStyling: false
                            });
                        })
                        .catch(err => {
                            swal.fire({
                                title: this.$t(err.response.data.Msg),
                                text: this.getErrorText(err.response.data),
                                icon: "error",
                                confirmButtonClass: "btn btn-danger btn-fill",
                                buttonsStyling: false
                            });
                        });
                }
            });
        },
        filesChange(files) {
            if (files[0].type != "image/png" && files[0].type != "image/jpeg") {
                swal.fire({
                    title: "Error",
                    text: "กรุณาเลือกไฟล์รูปภาพ",
                    icon: "error",
                    confirmButtonClass: "btn btn-danger btn-fill",
                    buttonsStyling: false
                });
            } else {
            }
            this.params.files = files[0];
        },
		GetProductUrl(filename){
			if (!filename) return ""
			if (filename.includes("http")){
				return filename
			}
			return process.env.VUE_APP_API_BASE_URL + "/files/products/" + filename
		},
		handleShowStockDetail(row) {
			var self = this
			this.selectedProduct = row
			this.stockDetailData = null
			this.showStockDetailModal = true

			this.calculateStock({})
				.then(function(resp) {
					console.log("resp.data.Datum:", resp.data.Datum)
					console.log("typeof Datum:", typeof resp.data.Datum)
					console.log("Is Array:", Array.isArray(resp.data.Datum))
					self.stockDetailData = resp.data.Datum
				})
				.catch(function(err) {
					self.showStockDetailModal = false
					var errorMsg = (err.response && err.response.data && err.response.data.Msg) ? err.response.data.Msg : "error"
					swal.fire({
						title: self.$t(errorMsg),
						text: "",
						icon: "error",
						confirmButtonClass: "btn btn-danger btn-fill",
						buttonsStyling: false
					});
				});
		},
		getRelatedSkuStock() {
			if (!this.stockDetailData || !this.selectedProduct) return []
			// stockDetailData is an array, filter by selected product's id
			var productId = this.selectedProduct
            if (!this.stockDetailData.sku_stock || !Array.isArray(this.stockDetailData.sku_stock)) return []
			return this.stockDetailData.sku_stock.filter(function(item) {
				return item.BoProductID === productId.id
			})
		},
		getRelatedWmsStock() {
			if (!this.stockDetailData || !this.selectedProduct) return []
			if (!this.stockDetailData.wms_product || !Array.isArray(this.stockDetailData.wms_product)) return []

			var self = this
			var relatedSkus = this.getRelatedSkuStock()
			var wmsProductIds = new Set()

			// Extract WMS product IDs from related SKUs
			relatedSkus.forEach(function(sku) {
				if (sku.WmsProductName) {
					var products = self.parseWmsProducts(sku.WmsProductName)
					products.forEach(function(product) {
						if (product.id) {
							wmsProductIds.add(parseInt(product.id))
						}
					})
				}
			})

			// Filter wms_product by the collected product IDs and merge stock data
			var wmsStockMap = {}
			if (this.stockDetailData.wms_stock && Array.isArray(this.stockDetailData.wms_stock)) {
				this.stockDetailData.wms_stock.forEach(function(stock) {
					wmsStockMap[stock.ProductID] = stock
				})
			}

			return this.stockDetailData.wms_product
				.filter(function(product) {
					return wmsProductIds.has(product.id)
				})
				.map(function(product) {
					var stockData = wmsStockMap[product.id] || {}
					return {
						...product,
						Stock: stockData.Stock || 0,
						Packing: stockData.Packing || 0,
						Balance: stockData.Balance || 0
					}
				})
		},
		formatDateTime(dateString) {
			if (!dateString) return '-'
			var date = new Date(dateString)
			return date.toLocaleString('th-TH', {
				year: 'numeric',
				month: '2-digit',
				day: '2-digit',
				hour: '2-digit',
				minute: '2-digit',
				second: '2-digit'
			})
		},
		parseWmsProducts(wmsString) {
			if (!wmsString) return []
			// Remove brackets and split by ],[ to get individual products
			// Example: [Swan(enabled=1|id=247|name=Swan|availabel=903|packing=10|balance=1139|sync_percent=0|sync_threshold=0)],[CSแดง(...)]
			var products = []
			// Remove leading [ and trailing ]
			var cleaned = wmsString.replace(/^\[|\]$/g, '')
			// Split by ],[ to get each product
			var productStrings = cleaned.split('],[')

			productStrings.forEach(function(productStr) {
				// Remove any remaining brackets
				productStr = productStr.replace(/[\[\]]/g, '')
				// Extract product name and details: ProductName(key=value|key=value|...)
				var match = productStr.match(/^([^(]+)\((.+)\)$/)
				if (match) {
					var productName = match[1]
					var detailsStr = match[2]
					var product = { name: productName }
					// Split by | to get key=value pairs
					var pairs = detailsStr.split('|')
					pairs.forEach(function(pair) {
						var keyValue = pair.split('=')
						if (keyValue.length === 2) {
							product[keyValue[0]] = keyValue[1]
						}
					})
					products.push(product)
				}
			})
			return products
		}
    }
};
</script>
<style>
.no-border-card .card-footer {
    border-top: 0;
}
.wms-product-item {
    padding: 4px 8px;
    background-color: #f8f9fa;
    border-radius: 4px;
    border-left: 3px solid #5e72e4;
}
.wms-product-item + .wms-product-item {
    margin-top: 8px;
}
</style>
<style>
.stock-detail-modal .modal-dialog {
    max-width: 95%;
    width: 95%;
    margin: 30px auto;
}
.stock-detail-modal .modal-content {
    max-height: 70vh;
}
.stock-detail-modal .modal-body {
    max-height: calc(70vh - 130px);
    overflow-y: auto;
}
</style>
